import React from "react";
import { Chip, Grid, Icon, Typography } from "@material-ui/core";
import { LocationCity } from "@material-ui/icons";
import { BuildingType } from "./building-form";

const BuildingDetailsShort: React.FC<BuildingType> =
({
  name,
  type,
  address1,
  address2,
  city,
  state,
  zip,
  bin,
  phase,
}) => <Grid item xs={12} sm={9} xl={10}>
  <Typography variant="h6"><Icon fontSize="small"><LocationCity /></Icon> {name}</Typography>
  <Typography variant="subtitle2">
    <Chip size="small" label={type} color="primary" variant="outlined" />
              &nbsp;
    {phase && <>
      <Chip
        size="small"
        label={phase.toLowerCase().startsWith("phase") ? phase : `Phase ${phase}`}
        color="primary"
        variant="outlined"
      />
                &nbsp;
    </>}
    {address2 ? `${address1} ${address2}` : address1
    },&nbsp;{city},&nbsp;{state}&nbsp;{zip}{bin && `| BIN ${bin}`}
  </Typography>
</Grid>;

export default BuildingDetailsShort;
